"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var useSelectItems = function () {
    var _a = React.useState([]), selected = _a[0], setSelected = _a[1];
    var selectItem = function (item) {
        setSelected(__spreadArray(__spreadArray([], selected), [item]));
    };
    var isNumbersArray = function (array) {
        return typeof array[0] === 'number';
    };
    var deselectItem = function (id) {
        var updatedSelected = selected === null || selected === void 0 ? void 0 : selected.filter(function (item) { return item !== id; });
        setSelected(updatedSelected);
    };
    var toggleSelectItem = function (id) {
        if (selected.includes(id)) {
            deselectItem(id);
            return;
        }
        selectItem(id);
    };
    var selectAll = function (items) {
        if (isNumbersArray(items)) {
            setSelected(items);
            return;
        }
        setSelected(items === null || items === void 0 ? void 0 : items.map(function (item) { return item.id; }));
    };
    var deselectAll = function () {
        setSelected([]);
    };
    var allItemsAreSelected = function (items) {
        if (isNumbersArray(items)) {
            return (items === null || items === void 0 ? void 0 : items.length) === (selected === null || selected === void 0 ? void 0 : selected.length) && items.every(function (item) { return selected.includes(item); });
        }
        return (selected === null || selected === void 0 ? void 0 : selected.length) === (items === null || items === void 0 ? void 0 : items.length) && items.every(function (item) { return selected.includes(item.id); });
    };
    var toggleSelectAll = function (items) {
        if (isNumbersArray(items)) {
            if (allItemsAreSelected(items)) {
                deselectAll();
            }
            else {
                selectAll(items);
            }
            return;
        }
        if (allItemsAreSelected(items)) {
            deselectAll();
        }
        else {
            selectAll(items);
        }
    };
    return [
        selected,
        selectItem,
        deselectItem,
        toggleSelectAll,
        toggleSelectItem,
        selectAll,
        deselectAll,
        allItemsAreSelected,
    ];
};
exports.default = useSelectItems;
